import { CLEAR_TIMELINE_DATA, FETCH_ALL_EMP, FETCH_ALLOC_ADMIN, FETCH_ALLOC_EMP, FETCH_ALLOC_LAUNCH_STATUS_ADMIN, FETCH_ALLOC_STATUS_ADMIN, FETCH_ALLOCATED, FETCH_ALLOCATED_EMP, FETCH_CONSENT, FETCH_CURRENT_DRIVE_CONFIG, FETCH_DASHBOARD_ADMIN, FETCH_DRIVE, FETCH_ELIGIBLE, FETCH_EMP, FETCH_JOINED, FETCH_LETTER_EMP, FETCH_MERIT, FETCH_PREVIOUS_POSTING, FETCH_REPORTS_HISTORY, FETCH_REPORTS_TYPES, FETCH_REVOKED_POSTING, FETCH_TIMELINE_EMP, FETCH_VACANCY, GRANT_PREVIOUS_POSTING, SEND_OTP_ACTION_ADMIN, SEND_OTP_FAILED_ACTION_ADMIN, SHOW_LOADER, UPDATE_ELIGIBILITY, UPDATE_JOINING, VACANCY_TEMPLATE_ADMIN } from "../actions/AdminActions";

const initialState={
    dashboarddata:{}
}
export function AdminReducer(state=initialState, action){
    
    switch(action.type){
        case FETCH_DASHBOARD_ADMIN:
            return {
                ...state,dashboarddata:action.payload
            }
        case FETCH_ALLOC_ADMIN:
            return {
                ...state,allocation:action.payload
            }
        case FETCH_ALLOC_STATUS_ADMIN:
            return {
                ...state,allocationstatus:action.payload
            }
        case FETCH_ALLOC_LAUNCH_STATUS_ADMIN:
            return {
                ...state,launchstatus:action.payload
            }
        case SEND_OTP_FAILED_ACTION_ADMIN:
            return {
                ...state,sendOTP:false
            }
        case SEND_OTP_ACTION_ADMIN:
            return {
                ...state,sendOTP:true
            }
        case SHOW_LOADER:
            return {
                ...state,loader:action.payload
            }
        case FETCH_ALLOCATED:
            return {
                ...state,allocated:action.payload
            }
        case FETCH_JOINED:
            return {
                ...state,joined:action.payload
            }
        case FETCH_ALLOCATED_EMP:
            return {
                ...state,allocatedEmp:action.payload
            }
        case FETCH_TIMELINE_EMP:
            return {
                ...state,timelineEmp:action.payload
            }
        case FETCH_LETTER_EMP:
            return {
                ...state,letterEmp:action.payload
            }
            case CLEAR_TIMELINE_DATA:
            return {
                ...state,
                timelineEmp: null
            };
        case UPDATE_JOINING:
            return {
                ...state,joiningStatus:action.payload
            }
        case UPDATE_ELIGIBILITY:
            return {
                ...state,eligibleStatus:action.payload
            }
        case FETCH_EMP:
            return {
                ...state,pending:action.payload
            }
        case FETCH_ELIGIBLE:
            return {
                ...state,eligible:action.payload
            }
        case FETCH_MERIT:
            return {
                ...state,merit:action.payload
            }
        case FETCH_DRIVE:
            return {
                ...state,drive:action.payload
            }
        case FETCH_CONSENT:
            return {
                ...state,consent:action.payload
            }
        case FETCH_REPORTS_TYPES:
            return {
                ...state,reportsTypes:action.payload
            }
        case FETCH_REPORTS_HISTORY:
            return {
                ...state,reportshistory:action.payload
            }
        case FETCH_REVOKED_POSTING:
            return {
                ...state,revokedposting:action.payload
            }
        case FETCH_VACANCY:
            return {
                ...state,drivevacancy:action.payload
            }
        case VACANCY_TEMPLATE_ADMIN:
            return {
                ...state,vacancyTemplate:action.payload
            }
        case FETCH_ALL_EMP:
            return {
                ...state,allEmployees:action.payload
            }
        case FETCH_PREVIOUS_POSTING:
            return {
                ...state,previousPosting:action.payload
            }
        case GRANT_PREVIOUS_POSTING:
            return {
                ...state,grantPreviousPosting:action.payload
            }
        case FETCH_CURRENT_DRIVE_CONFIG:
            return {
                ...state,currentDriveConfig:action.payload
            }
       
        default:
            break;
    }
    return state;
}